import Template from './template.component';
import * as WebViewActions from '@medscape-promo/medscapetv/web-view/web-view.actions';
import { connect } from 'react-redux';
import { VIEWED_MODULES_TRACKING } from '@medscape-promo/medscapetv/omniture-tracking';
const { mmodule, mlink } = VIEWED_MODULES_TRACKING;

const mapStateToProps = (state, ownProps) => {

    const props = Object.assign({}, ownProps, {
    	"linksTarget": state.WebView.isIframe === true ? "_blank" : ""
    });

    return props;
};

const mapDispatchToProps = dispatch => {
    return {
    	onMount: (offsetHeight) => {
    		dispatch(WebViewActions.omnitureTracking(`${mmodule}_${mlink["series-info"]}`));
    	}
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(Template);
